import React from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import store from "./store/store";
import { Provider } from "react-redux";
import { I18nextProvider } from "react-i18next";
import i18next from "./translations/translations";
import { ThemeProvider } from "styled-components";
import { theme } from "./constants/common/StyledGlobalConstants";
// START - REDBALL CONFIG 
import { Auth0Provider } from '@auth0/auth0-react';
import { getConfig } from "./config";
import { REDBALL_FEATURE_TOGGLE } from "./constants/appConstants";
import {checkNonQADomain, checkImpersonateUser} from "./util/util";

const config = getConfig();
const nonQADomain = checkNonQADomain();
const checkImpersonate = checkImpersonateUser();
const providerConfig = {
  domain: config.domain,
  clientId: config.clientId,
  //onRedirectCallback,
  useRefreshTokens: true,
  cacheLocation: "localstorage",
  authorizationParams: {
    redirect_uri: window.location.href,
    ...(config.audience ? { audience: config.audience } : null),
  },
};
// END - REDBALL CONFIG 

const container = document.getElementById("root");
const root = createRoot(container);
root.render(
    <I18nextProvider i18n={i18next}>
      <Provider store={store}>
        <ThemeProvider theme={theme}>
          {/*// START - REDBALL CONFIG */}
          {REDBALL_FEATURE_TOGGLE && nonQADomain && !checkImpersonate ? (
            <Auth0Provider
              {...providerConfig}
            >
              <App />
            </Auth0Provider>
          ) : (
            <App />
          )}
          {/*// END - REDBALL CONFIG  */}
        </ThemeProvider>
      </Provider>
    </I18nextProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
